module.exports = __webpack_public_path__ + "img/manutencao_image.6ccbdeff.jpg";